import axios from 'axios'

export const TRANSCRIPTION_URL = '/api/rest/cas/speechtextview'

export default {
  async getTranscription(ccrid, isRootRecording) {
    try {
      const response = await axios.put(TRANSCRIPTION_URL, {
        ccrid,
        isRootRecording,
      })

      return {
        texts: [],
        ccrId: ccrid,
        ...response.data,
      }
    } catch (error) {
      throw new Error(error)
    }
  },
}
